//
// Composant qui fait le carré de couleur clicable dans l'édition des sorties
//


<template>

    <a @click="colorChoosed" class="picker" :style="style"></a>

</template>

<script>
    export default {
        name: 'tabltask',
        data (){
            return {

            }
        },
        components: {},
        props: ['color'],
        computed: {
            style(){
                return 'background-color: '+this.color
            }

        },
        methods: {

            colorChoosed(){
                this.$emit("onSelection",this.color)
            }

        },
        mounted(){

        }
    }

</script>


<style lang="scss" scoped>
    .picker {
        width:15px;
        height:15px;
        margin:2px;
        float:left
    }

</style>